/* oxlint-disable react/jsx-no-target-blank */
import * as React from 'react';

import * as styles from './styles/subscriptionContent.css';

const SQUARE_METER = '\u00B2';

export interface ISubscriptionContentProps {
  title: string;
  subtitle: string;
  children?: React.ReactNode;
  url?: string;
}

export function SubscriptionContent({ title, subtitle, children, url }: ISubscriptionContentProps) {
  return (
    <div className={styles['content']}>
      {getTitle(title, url)}
      <div className={styles['subtitle']}>{subtitle}</div>
      {children}
    </div>
  );
}

function getTitle(title: string, url?: string) {
  const parsedTitle = replaceSupTag(title);

  return url ? (
    <a href={url} className={styles['title']} target="_blank">
      {parsedTitle}
    </a>
  ) : (
    <div className={styles['title']}>{parsedTitle}</div>
  );
}

function replaceSupTag(title: string) {
  const regex = /<sup>.*<\/sup>/;

  return title.replace(regex, SQUARE_METER);
}
